export default "__VITE_ASSET__BrZPSzB6__"